module.exports = __webpack_public_path__ + "static/img/footer.d61496a4.png";